import {
  type GqlCompany,
  type GqlIdentity,
  type GqlOptionsRegistration,
  type GqlWarrantParticipant,
  type GqlWarrantProgram,
} from '../../../../graphql/base-types.graphql';
import { type ComponentProps, Suspense } from 'react';
import { WarrantAgreementDocument } from './WarrantAgreementDocument';
import { type DisplayIdentity } from '@startuptools/business-ui/identity/Identity';
import { type DisplayDocument } from '@startuptools/business-ui/document/Document';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { useCompanySuspenseQuery } from '../../../../graphql/react-operations';

const WarrantAgreementDocumentsListInner = ({
  company,
  warrantProgram,
  optionsRegistration,
  participants,
  navigateToDecisionStep,
}: {
  company: Pick<GqlCompany, 'id' | 'name' | 'allowShortQeso'>;
  warrantProgram: Pick<GqlWarrantProgram, 'id' | 'name' | 'warrantKind' | 'usesStepper' | 'paidForAt' | 'companyId'>;
  optionsRegistration: Pick<GqlOptionsRegistration, 'id' | 'description'>;
  participants: (Pick<GqlWarrantParticipant, 'id' | 'optionsRegistrationId'> & {
    identity: DisplayIdentity & Pick<GqlIdentity, 'juridicalKind'>;
    latestAgreementDoc?: DisplayDocument | undefined | null;
  })[];
  navigateToDecisionStep: () => void;
}) => {
  return (
    <>
      {participants.map(p => {
        return (
          <WarrantAgreementDocument
            key={p.id}
            company={company}
            warrantProgram={warrantProgram}
            optionsRegistration={optionsRegistration}
            participant={p}
            navigateToDecisionStep={navigateToDecisionStep}
          />
        );
      })}
    </>
  );
};

// export const WarrantAgreementDocumentsList = (props: ComponentProps<typeof WarrantAgreementDocumentsListInner>) => {
export const WarrantAgreementDocumentsList = (
  props: Pick<
    ComponentProps<typeof WarrantAgreementDocumentsListInner>,
    'optionsRegistration' | 'participants' | 'warrantProgram' | 'navigateToDecisionStep'
  >,
) => {
  const companyId = useCompanyId();
  const {
    data: { company },
  } = useCompanySuspenseQuery({ variables: { id: companyId } });

  return (
    <Suspense>
      <WarrantAgreementDocumentsListInner company={company} {...props} />
    </Suspense>
  );
};
